import api from "../axios";
import * as Requests from "../requests";
import { TLoyaltyCategory } from "../../types";

export const getLoyaltyMenuApi = async (
  token: string
): Promise<TLoyaltyCategory[]> => {
  return await (
    await api.get(Requests.storeItems, {
      headers: {
        token,
      },
    })
  ).data;
};
